<template>
  <div>
    <md-button class="md-primary" @click="onDoneClick">Done</md-button>
  </div>
</template>

<script>
import { eventBus } from "../../../eventbus";
export default {
  name: "IsDoneDialogAction",
  methods: {
    onDoneClick: function () {
      // go to calendar
      eventBus.adminTabChanged("home");
      this.$router.push("/admin");
    },
  },
};
</script>

<style>
</style>